import React from 'react';
import PropTypes from 'prop-types';
import EventDetailProviderWrapper from './EventDetailProvider';
import EventDetailLayout from './EventDetailLayout';

const EventDetailPage = ({ subview }) => (
    <EventDetailProviderWrapper subview={subview}>
        <EventDetailLayout />
    </EventDetailProviderWrapper>
);

EventDetailPage.propTypes = {
    subview: PropTypes.oneOf(['', 'sessions', 'agenda', 'availability']),
};

export default EventDetailPage;
